<template>
    <div class="commentary mt-5">
        <div>
            <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
                <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
            </div>
        </div>
        <div class="row highlights justify-content-center">
            <div class="col-12 d-flex flex-column justify-content-center">
                <div v-if="errors" class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                <div v-else class="fr-text key-wrap flex-grow-1 px-5 pb-4">
                    <h1 class="mt-3 mb-2">{{commentaryData.name}}</h1>
                    <p v-html="commentary">{{commentary}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'commentaryData'],
        created() {
            if(this.isBuilt){
                this.fetchServerData();
            }
        },
        data() {
            return {
                isArchive:this.$store.state.isArchive,
                commentary:'',
                errors:false,
                reloading:true
            }
        },
        mounted(){
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        methods: {
            fetchServerData(){
                let params = {
                    'isArchive':            this.isArchive,
                    'prefixed_id':          this.isArchive ? this.commentaryData.archive_id : this.commentaryData.report_id,
                    'prefixed_element_id':  this.commentaryData.report_element_id,
                    'element_abbr':         this.commentaryData.element_abbreviation,
                    'element_id':           this.commentaryData.element_id,
                    'element_name':         this.commentaryData.name,
                };
                axios.post('/api/reporting/element', params).then((response) => {
                    if(!!response.data && (typeof(response.data) == 'object')){
                        this.commentary = response.data.commentary;
                        this.errors = response.data.errors;
                    }
                    this.reloading = false;
                });
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.commentary{
        div.highlights{
            div.key-wrap{
                border-radius:2rem;
                border:0.2rem solid $black-blue;
                h1{
                    font-size:2rem;
                }
            }
        }
    }
</style>
